import { render, staticRenderFns } from "./WriteaCheck.vue?vue&type=template&id=fc3bd1b4&scoped=true"
import script from "./WriteaCheck.vue?vue&type=script&lang=js"
export * from "./WriteaCheck.vue?vue&type=script&lang=js"
import style0 from "./WriteaCheck.vue?vue&type=style&index=0&id=fc3bd1b4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3bd1b4",
  null
  
)

export default component.exports